export default {
	install(Vue, options) {
		Vue.prototype.langConfig = {
			curLang: (function () {
				let _hostname = window.location.hostname;
				if (_hostname.indexOf('en') > -1) {
					return 'en';
				}
				if (_hostname.indexOf('kr') > -1) {
					return 'kr';
				}
				if (_hostname.indexOf('th') > -1) {
					return 'th';
				}
				if (_hostname.indexOf('vn') > -1) {
					return 'vn';
				}
				return 'en';
			})(),

			txtLang: {
				'en': {
					'LOGO_TXT': 'en.upgoal.com',
					'STATE_ARR_MATCHDETAILS': ["", "1st", "HT", "2nd", "FINISHED", "INTERRUPTED", "CANCELLED", "Extra", "AFTER EXTRA TIME", "Extra", "120 Minutes", "PENALTIES", "Finished", "POSTPONED", "ABANDONED", "PENDING", "Gold", "Upcoming","AFTER PENALTIES","AFTER EXTRA TIME"],
					'STATE_ARR': ["", "1st", "HT", "2nd", "FT", "Pause", "CANC", "Extra", "Extra", "Extra", "120 Minutes", "Pen", "Finished", "Postponed", "Cut", "Undecided", "Gold", "Upcoming", "AP", "AET"],
					'STATE_ARR_FULL': ["", "1st Half", "HALF-TIME", "2nd Half", "FINISHED", "Pause", "CANCELLED", "Extra", "Extra", "Extra", "120 Minutes", "PENALTIES", "Finished", "Postponed", "Cut", "Undecided", "Gold", "Upcoming", "AFTER PENALTIES", "AFTER EXTRA TIME"],
					'NAV_TAB': [
						{
							'id': 0,
							'path': '/',
							'name': 'Home'
						},
						{
							'id': 1,
							'path': '/prediction',
							'name': 'Prediction'
						},
						{
							'id': 5,
							'path': '/news/0',
							'name': 'News'
						},
						// {
						// 	'id': 6,
						// 	'path': '/fixturePoster',
						// 	'name': 'Match Poster'
						// },
						{
							'id': 7,
							'path': '/about',
							'name': 'About'
						},
					],
					'POP_NAV': [
						{
							'id': 0,
							'name': 'My Leagues'
						},
						{
							'id': 1,
							'name': 'Setting'
						}
					],
					'DAY_WEEK': ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Today"],
					'DAY_WEEK_SORT': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Today'],
					'CONFIRM': 'Confirm',
					'CANCEL': 'Cancel',
					'TOP_LEAGUES': 'Top Leagues',
					'MY_LEAGUES': 'Manage My Leagues',
					'NEWS': 'News',
					'ALL_LEAUGES': 'All Leagues',
					'ALL_NEWS': 'All News',
					'NO_DATA': 'No data',
					'LOADING': 'loading...',
					'MODEL_TITLE': ['Poisson', 'Margin', 'Divergence'],
					'MODEL_TITLE2': ['Poisson Prediction', 'Margin Prediction', 'Divergence Prediction'],
					'TAB_TITLE': ['1x2', 'asianHandicap', 'OverUnder', 'correctScores', 'goals'],
					'MOOTH_SORT': ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'],
					'GENER': ['Generate Poster', 'Exit selection mode'],
					'GENER_SEL': ['Add to poster', 'Added'],
					'LOG_IN_TIPS': 'Sign In to get more',
					'OTHERS': 'Others',
					'MODEL_SUB_TITLE': ['Predictions based on Poisson distribution for match outcomes.' , 'Analysis of bookmaker profit margins.', 'Changes between opening and current betting odds.'],
					'PLAY_TITLE': ['1x2', 'Asian Handicap', 'Goals Over/Under', 'Correct Scores', 'Goals'],
					'PLAY_EVENT': ['1x2', 'AH', 'O/U', 'Scores', 'Goals'],
				},
			},
			login: {
				'en': {
					'LOGIN': 'Sign In',
					'LOGOUT': 'Log Out',
					'SIGNUP': 'Sign Up',
					'SIGN_UP_MORE': 'Sign up to get more',
					'FOLLOW_MATCHES': 'Follow your favorite matches',
					'VIEW_NEWS': 'View advanced services like VIP News',
					'SYNC_DEVICES': 'Sync the settings across different devices',
					'CONTINUE_EMAIL': 'Sign in with Email',
					'LOGIN_TIPS': 'By clicking on “Sign in with email”, you agree to <a href="/terms">the Terms of Service</a> and acknowledge our <a href="/privacy">Privacy Policy</a>.',
					'BACK': 'Back',
					'LOGIN_ACCOUNT': 'Sign In to Your Account',
					'CREATE_ACCOUNT': 'Create a New Account',
					'REGISTRATION': 'Registration complete!',
					'FORGOT': 'Forgot Password?',
					'PASSWORD_RESET': 'A password reset email has been sent to you',
					'RESET': 'Reset Password',
					'RESET_SUCCESS': 'Your password has been reset successfully!',
					'ACCOUNT_SUCCESS': 'Your account has been successfully activated and you can now Sign In.',
					'NEW_PASSWORD': 'Please enter your registered email address and we will send a verification email for you to reset a new password.',
					'SEND': 'Send',
					'SAVE': 'Save Changes',
					'GOT_IT': 'I got it',
					'EMAIL_FORMAT': 'Email format is incorrect, please re-enter',
					'LEAST_DIGITS': 'Please enter at least 6 digits.',
					'INCONSISTENT': 'Inconsistent passwords',
					'REGISTER_VER': 'We have sent a registration verification email to your registered email address <span>[?1]</span>.<br />Please check your mailbox and confirm your registration, thank you!',
					'PASSWORD_VER': 'We have sent a password reset verification email to your registered email address <span>[?1]</span>.<br />Please check your mailbox and reset your password, thank you!',
					'EMAIL_REGISTER_TIPS': 'If you don\'t have an account, please <span id="SignUp">Sign Up</span>',
					'EMAIL_LOGIN_TIPS': 'If you have an account, please <span id="LogIn">Sign In</span>',
					'SINGUP_TIPS': 'By clicking on the "Sign up" button, you agree to <a href="#/terms">the Terms of Use</a> and acknowledge our <a href="#/privacy">Privacy Policy</a> on our website.',
					'ACCOUNT_NOT_ACTIVE': 'The account has not been activated.',
					'ACCOUNT_NOT_ACTIVE_TIPS': 'Please check the registration verification email in your registered email <span>[?1]</span> and activate your account through that email.<br />If you have not received the email, you can click the button below to resend it.',
					'SEND_AGAIN': 'Send the verification email again.',
					'CLOSE': 'Close',
					'REGISTER_AGAIN_TIPS': 'A registration verification email has been sent to your registered email address  <span>?1</span>.<br /> Please activate your account with this email. <br />If you do not receive the email, you can resend it by clicking the button below.',
					'RESEND_TIPS': 'After resending, the previous verification link will automatically expire. <br />Some email providers may mistakenly identify the emails as spam, please pay attention to your inbox.',
					'ACTIVE_FAIL': 'Activation Failure',
					'LINK_EXPIRED': 'The activation link you used has expired, please resend the verification email by logging into your account.',
					'PASSWORD_LINK_EXPIRED': 'The verification link you used has expired. If you still need to retrieve your password, please initiate a new request.',
					'RETRIEVE_PASSWORD': 'Retrieve Password',
					'RESET_PASSWORD_FAIL': 'Reset password failed',
					'PLACEHOLDER_EMAIL': 'Email',
					'PLACEHOLDER_PWD': 'Password',
					'PLACEHOLDER_PWD2': 'Password again',
					'PLACEHOLDER_CODE': 'Verification Code',
					'PLACEHOLDER_EMAIL_C': 'Enter your email address',
					'PLACEHOLDER_PWD_C': 'Create password (at least 6 characters)',
				},
			},
			setting: {
				'en': {
					'DARK_MODE': 'Dark mode',
					'SOUND': 'Sound',
					'TIME_ZONE': 'Time zone',
					'ORDER_BY': 'Order matches by:',
					'LEAGUES': 'Leagues',
					'KICK_OFF': 'Kick-off Time',
					'ODDS_TYPES': 'Odds Types:',
					'ODDS_FORMAT': 'Odds Formats:'
				},
			},
			footer: {
				'en': {
					'FOOTBALL': 'FOOTBALL',
					'HOME': 'Home',
					'SCORE': 'Scores',
					'LEAGUES': 'Leagues',
					'TRANSFER': 'Transfer',
					'PREDICTION': 'Prediction',
					'NEWS': 'News',
					'POSTER': 'Fixture Poster',
					'ABOUT': 'ABOUT',
					'TERMS': 'Terms of Service',
					'PRIVACY': 'Privacy Policy',
					'SITMAP': 'Sitemap',
					'FOLLOW_US': 'FOLLOW US',
					'SUB_TITLE': 'Subscription Notification',
					'SUB_INTRO': 'Subscribe now for the latest analysis and predictions of popular matches, trending news, and recent marketing activities, allowing us to build a stronger connection with you.',
					'SUB_BTN': 'Subscription',
					'NOTE': 'Note: Advertisements on upgoal.com are agreed upon by both parties to the contract. Upgoal does not guarantee the authenticity of the information in above advertisements. Upgoal is not responsible for all transactions between you and the advertisers.',
					'COPY_RIGHT': 'Copyright ©2024 LuckScore.com. All rights reserved.',
					'COOKIE_TIPS': 'We use cookies for basic functionality and to collect anonymous data for analysis to improve your experience. By understanding how you use our products, we can build better features and provide you with more valuable content and marketing information. For more information about cookies, please see our <a href="/privacy">Privacy Policy</a>. By continuing to use this site you are agreeing to our use of cookies and personal data.',
					'SUB_SUCCESS_TIPS': 'You have successfully subscribed to platform notifications.',
					'CLOSE': 'Close',
					'SUB_ERRO_TIPS': 'Please enter the correct Email format, e.g. xx@xx.com.',
					'SUB_PLACEHOLDER': 'Email Address',
				},
			},
			index: {
				'en': {
					'LIVE_TAB': [
						{
							'id': 0,
							'name': 'All'
						},
						{
							'id': 1,
							'name': 'Live'
						},
						{
							'id': 2,
							'name': 'Odds'
						},
						{
							'id': 3,
							'name': 'FT'
						},
						{
							'id': 4,
							'name': 'Scheduled'
						}
					],
					'ODDS_TYPE_ARR': ['threeWayLuckMatch', 'asianLuckMatch', 'totalLuckMatch'],
					'LINEUP_POST': 'The official line-up of this game is posted.',
					'TIPS_PRO': 'Tips are provided for this game.',
					'STANDING': 'Standings',
					'ADD_MY_FAVORITES': '<div class="flex flex-align-center"><a href="/favorites" class="flex flex-align-center favPop"><span>Added to My Favorites.</span><i class="icon-font icon-arr favArr"></i></a></div>',
					'REMOVED_MY_FAVORITES': '<div><span>Removed from My Favorites.</span></div>',
					'ADD_MY_LEAGUES': '<div class="flex flex-align-center"><a class="flex flex-align-center favPop"><span>Added to My Leagues.</span></a></div>',
					'REMOVED_MY_LEAGUES': '<div><span>Removed from My Leagues.</span></div>',
					'DISPLAY_MATCHES': 'Display Matches',
					'FINISHED': 'Finished',
					'ODDS_TYPE_TAB': [
						{
							id: 2,
							name: 'AH'
						},
						{
							id: 3,
							name: 'O/U'
						},
						{
							id: 1,
							name: '1x2'
						},
						{
							id: 4,
							name: 'Close'
						},
					],
					'RANK': {
						'TITLE': 'Prediction Performance',
						'MODEL_TAB': ['Hit Rate', 'YIELD'],
						'HIT': '?2/?1 correct predictions',
						'TIPS': ['The percentage of correct predictions.', 'The return on investment from betting.'],
						'RANK_EVENT': ['首页-Poisson排行榜', '首页-Margin排行榜', '首页-Divergence排行榜']
					},
					'HOT_PRED': {
						'HP_TITLE': ['Scores', 'Goals'],
						'GOAL': '?1 goal',
						'GOALS': '?1 goals',
						'HP_ODDS': ['AH', 'O/U', '1x2'],
						'RESULTS': 'WIN',
						'HOME': 'Home',
						'AWAY': 'Away',
						'DRAW': 'Draw',
						'OU_TXT': ['Over ?1 goal', 'Under ?1 goal'],
						'OU_TXT_S': ['Over ?1 goals', 'Under ?1 goals'],
						'WIN': ['Home Win', 'Draw', 'Away Win'],
						'OU_TXT_M': ['Over ?1 goal', 'Under ?1 goal'],
					},
					'SORT_TAB': ['Kick-off Time', 'Hit Rate', 'YIELD'],
					'LEAGUE_SORT': ['All', 'Following'],
					'PLAY_TITLE': {
						'1': 'Goals',
						'2': '1x2',
						'3': 'Goals Over/Under',
						'4': 'Correct Scores',
						'5': 'Asian Handicap'
					}
				},
			},
			favorites: {
				'en': {
					'FILTER_TAB': [
						{
							'id': 0,
							'name': 'Timeline'
						},
						{
							'id': 1,
							'name': 'Yesterday'
						},
						{
							'id': 2,
							'name': 'Live'
						}
					],
					'UNFOLLOW_TIPS': 'Are you sure to unfollow the match?',
					'UNFOLLOW': 'Unfollow',
					'CLOSE': 'Close'
				},
			},
			details: {
				'en': {
					//
					'REMARKS': {
						'90min': '90 minutes ?1-?2',
						'first': 'First Leg ?1-?2',
						'second': 'Aggregated ?1-?2',
						'120min': '120 minutes ?1-?2',
						'penalyty': 'Penalty Shootout ?1-?2',
					},
					'PROBABILITY': {
						'card_again': 'Probability of another card.',//再获得罚牌概率
						'card_first': 'Probability distribution of first card.',//首罚概率分布
						'goal_again': 'Probability of another goal.',//再进球概率
						'goal_first': 'Probability distribution of first goal.',//首入球概率分布
					},
					'EVENT_SUMMARY': {
						1: 'Goals scored',//'进球'
						2: 'Penalty  ',//'点球',
						3: 'Own goals',//'乌龙球',
						4: 'Yellow card',//'黄牌',
						5: '2Y to R',//'两黄变一红',
						6: 'Red card',//'红牌',
						7: 'Substitutions',//'替换球员',
						8: 'Penalty shootout begins!',//'点球大战开始',
						9: 'Penalty scored',//'点球射进',
						10: 'Penalty missed',//'点球射失',
						'-1': ''// 换下（XX球员）
					},
					'PICKERLIST': [{
						value: 'currentSeason',
						name: 'This season'//'本赛季'
					}, {
						value: 'recentTen',
						name: 'The last 10 games'//'近10场'
					}, {
						value: 'recentTwenty',
						name: 'The last 20 games'//'近20场'
					}],
					'COUNT_DOWN': {
						'tomorrow': 'The match starts tomorrow.',//明天开赛
						'after_tomorrow': 'The match starts the day after tomorrow.',//后天开赛
						'nDays': function (n) {
							return 'In ' + n + ' days.'//N天后开赛
							// return 'The match starts in ' + n + ' days.'//N天后开赛
						},
						//5中断 6取消 8加时 11点球 13延期 14腰斩 15待定 
						'5': 'Undetermined',//
						'6': 'Cancel',//
						'13': 'Postponed',//
						'14': 'Abandoned',//
						'15': 'Undetermined',//
					},
					"KEYLIST": {
						'critical_event': 'Key events',//关键事件
					},
					"SUMMARY": {
						'1ST_HALF': '1ST Half',
						'2ST_HALF': '2ND Half',
						'EXTRA_TIME': 'Extra time',
						'PENALTY_SHOOTOUT': 'Penalty shootout',
						'MATCH_INFO': 'Match Info',
						'HOME_AWAY': 'Home/Away',
						'GOALS': 'Goals',
						'CARDS': 'Cards',
					},
					"LINEUP": {
						'critical_event': 'Key events',//关键事件
						'STARTING_LINEUP': 'Starting Lineups',
						'PREDICTED_LINEUP': 'Predicted Lineups',
						'SUBSTITUTIONS': 'Substitutions',
						'THE_BENCH_PLAYERS': 'The bench players'
					},
					"EVENT": {
						0: { name: 'Statistic' },//统计事件
						1: { name: 'The game begins!', title: '1ST Half' },//比赛开始
						3: { name: 'The game begins! ' },//比赛结束
						4: { name: 'The 2nd half begins.', title: '2ND Half' },//下半场开始
						8: { name: 'Penalty' },//获取点球
						9: { name: 'Goals' },//进球
						18: { name: 'Yellow card' },//黄牌
						21: { name: "2Y to R" },// 黄红牌
						22: { name: "Red card" },// 红牌
						23: { name: "Substitutions" },// 替补
						24: {// 伤停补时显示
							name: "",
							text(val) { return 'The match goes into stoppage time, ' + val + ' minutes of time to be added.' }
						},
						26: { name: "Free-Kicks" },// 任意球
						30: { name: "Corner" },// 角球
						31: { name: "Shot Missed (On target)" },// 射正不进
						32: { name: "Off target" },// 射偏
						34: { name: "Injuries" },// 受伤
						40: { name: "Penalty missed" },// 点球射失
						41: { name: "Penalty shootout begins", title: '' },// 点球决胜开始
						115: { name: "End of first half of extra time" },// 加时赛上半场结束
						116: { name: "Extra time begins." },// 加时赛结束
						134: { name: "The 2nd half begins." },// 上半场结束
						135: { name: "Extra time begins.", title: 'Extra time' },// 加时上半场开始
						136: { name: "Start of second half of extra time" },// 加时下半场开始
						137: { name: "Extra time begins." },// 点球进球
						138: { name: "Penalty Missed" },// 点球射失
						156: { name: "Goal confirmed" },// 进球确认(VAR视频裁判事件，0取消进球1确认进球)
						157: { name: "Yellow card upgraded confirmed" },// 罚牌升级确认(VAR视频裁判事件，0不升级1升级)
						158: { name: "No goal confirmed" },// 未进球确认(VAR视频裁判事件，0进球 1未进球)
						159: { name: "Penalty confirmed" },// 点球确认(VAR视频裁判事件，0点球取消1确认点球)
						160: { name: "Red card" },// 红牌确认(VAR视频裁判事件，0红牌取消 1确认红牌)
						161: { name: "No penalty confirmed" },// 不判罚点球确认(VAR视频裁判事件，0判罚点球1不判罚点球)
						162: { name: "Foul player confirmed" },// 犯规球员确认(VAR视频裁判事件，0没有犯规1判罚犯规)
						9999: { name: "Stadium information" },// 球馆信息
					},
					'ODDS': {
						'1x2': '1x2',
						'ASIAN': 'Asian Handicap',
						'OVER_UNDER': 'Over/Under',
						'BOOKMAKERS': 'Bookmakers',
						'GOALS': 'Goals',
						'OVER': 'Over',
						'UNDER': 'Under',
						'INITIAL_ODDS': 'Initial Odds',
						'LIVE_ODDS': 'Live Odds',
						'HISTORY_CHANGE': 'History of Odds Change',
						'WIN_RATE': 'Win Rate',
						'TIME': 'Time',
						'HOME_WIN_RATE': 'Home Win Rate',
						'DRAW_RATE': 'Draw Rate',
						'AWAY_WIN_RATE': 'Away Win Rate',
						'RETURN': 'Return',
						'HOME': 'Home',
						'HANDICAP': 'Handicap',
						'AWAY': 'Away',
						'TOTAL': 'Total',
						'OVER': 'Over',
						'UNDER': 'Under',
						'INITIAL': 'Initial',
						'LIVE': 'Live',
						'PUSH': 'Push'
					},
					'H2H': {
						'H2H_MATCHES': 'Head-to-head',
						'HOME_VS_AWAY': 'Home vs Away',
						'HT': 'HT',
						'FT': 'FT',
						'AH': 'AH',
						'OU': 'O/U',
						'RECENT_RECORD': 'Recent Record',
						'COMPETION': 'Competition',
						'LAST_GAMES': 'Last ?1 games',
						'WON': 'Won',
						'DRAW': 'Draw',
						'LOST': 'Lost',
						'WIN': 'Wins (AH)',
						'PUSH': 'Pushes (AH)',
						'LOSE': 'Losses (AH)',
						'W': 'W',
						'D': 'D',
						'L': 'L',
						'GOAL_SCORED': 'Goals scored per game',
						'GOAL_CONCEDED': 'Goals conceded per game',
						'CLEAN_SHEETS': 'Clean sheets',
						'INDENTICAL_LINES': 'Indentical Lines',
						'TEAM_RECENT_RECORD': '?1 Recent Record',
						'TEAM_INDENTICAL_LINES': '?1 Indentical Lines',
						'INITIAL_ODDS': 'Initial Odds',
						'RESULT_ARR': ["", "W", "", "L", "", "D"],
						'RESULT_ARR2': ["", "O", "", "U", "", "D"],
						'UPCOMING_GAMES': 'Upcoming 3 Games',
						'DAYS_LATER': '?1 Days Later'
					},
					'STANDING': {
						'LIVE_STANDING': 'LIVE STANDING',
						'FORM': 'Form',
						'FULL': 'Full',
						'HOME': 'Home',
						'AWAY': 'Away',
						'ALL': 'All',
						'TABLE_HEAD': [
							"",
							"",
							"Played",
							"W",
							"D",
							"L",
							"GF/GA",
							"GD",
							"PTS",
							"Last Matches",
						]
					},
					'TAB_LIST': {
						'MATCH': 'Match',
						'SUMMARY': 'Summary',
						'STATS': 'Stats',
						'LINEUP': 'Lineups',
						'EVENT': 'Events',
						'ODDS': 'Odds',
						'H2H': 'H2H',
						'STANDING': 'Standings',
						'PREDICTION': 'Prediction'
					},
					'TAB_EVENT': {
						'ALL': 'ALL',
						'GOALS': 'Goals',
						'CORNERS': 'Corners',
						'CARDS': 'Cards'
					},
					'LABEL_TIPS': {
						'HOME': 'Home',
						'AWAY': 'Away',
						'GOALS_SCORED': 'Goal scored',
						'PENALTY': 'Penalty',
						'PENALTY_MISSED': 'Penalty Missed',
						'CORNER': 'Corner',
						'INJURIES': 'Injuries',
						'SUBSITUTIONS': 'Substitutions',
						'STATE': 'State',
						'FREE_KICKS': 'Free-Kicks',
						'SHOT_MISSED': 'Shot Missed (On target)',
						'OFF_TARGET': 'Off target',
						'YELLOW_CARDS': 'Yellow card',
						'RED_CARDS': 'Red card',
						'STATISTIC': 'Statistic',
						'OWN_GOALS': 'Own goal',
						'IN': 'IN',
						'OUT': 'OUT',
						'2Y_TO_R': '2Y to R'
					},
					'PREDICTION': {
						'MASTER_M': 'Master M',
						'PREDICTED_SCORE': 'Predicted Score:',
						'FORTUNE_TELLER': 'Fortune Teller:',
						'AFTER_LOGIN': 'After login, you can check the details.',
						'LOG_IN': 'Sign In',
						'NOTE': 'Note: The views expressed above are those of the authors and do not necessarily reflect the view of the site.',
					},
				},
			},
			leagues: {
				'en': {
					'POINTS': 'Points',
					'AH': 'AH',
					'FIXTURES': 'Fixtures',
					'MORE': 'More',
					'ALL_LEAGUES': 'All Leagues',
					'ORDER': 'Order',
					'OPTIONAL': 'Optional',
					'TOURNAMENT_PHASES': 'Tournament Phases',
					'START_TIME': 'Start Time',
					'OPTIONAL_PHASE': 'Optional Phase',
					'SELECT_ALL': 'Select All',
					'INVERT_SELECTION': 'Invert Selection',
					'CONFIRM': 'Confirm',
					'ALL': 'All',
					'HOME': 'Home',
					'AWAY': 'Away',
					'TABLE_HEAD_POINTS': [
						"Team",
						"Played",
						"W",
						"D",
						"L",
						"GF/GA",
						"GD",
						"PTS",
						"Last Matches",
					],
					'TABLE_HEAD_AH': [
						"Team",
						"Played",
						"Started",
						"HC",
						"W/P/L",
						"Win",
						"Push",
						"Loss",
						"+/-",
						"Winning Rate",
						"Last Matches",
					],
					'COMPETITION_SYSTEM_DESCRIPTION': 'Competition system description',
					'FOOTBALL': 'Soccer',
					'LEAGUES': 'Leagues',
					'ALL_LEAGUES': 'ALL Leagues',
					'TEAMS': 'Teams',
					'PLAYERS': 'Players',
					'FILTER': 'Filter',
					'Results': 'Results',
					'Data': 'Data',
					'Line-up': 'Line-up',
					'Transfer': 'Transfer',
					'Information': 'Information',
				},
			},
			privacy: {
				'en': {
					'PRIVACY_TITLE': 'Privacy Policy',
					'PRIVACY_TEXT': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra'
				}
			},
			terms: {
				'en': {
					'TERMS_TITLE': 'Terms of Service',
					'TERMS_TEXT': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra'
				}
			},
			'404': {
				'en': {
					'BACK': 'Back to home page'
				},
			},
			'500': {
				'en': {
					'BACK': 'Back to home page'
				},
			},
			news: {
				'en': {
					'ALL': 'All',
					'TOP_NEWS': 'Top News',
					'PREVIOUS': 'Previous',
					'NEXT': 'Next',
					'NEWS': 'News',
					'MAIN_TEXT': 'Main Text',
					'POSTED': '',
					'BY': 'by'
				},
			},
			account: {
				'en': {
					'ACCOUNT_INFO': 'Account Information',
					'OLD_PASSWORD': 'Old Password',
					'NEW_PASSWORD': 'New Password',
					'CONFIRM_PASSWORD': 'Confirm Password',
					'EMAIL': 'Email',
					'RESET_SUCCESS': 'Password changed successfully!',
					'PLACEHOLDER_PWD1': 'Leave blank to keep current password',
					'PLACEHOLDER_PWD2': 'Minimum 6 characters, include letters and numbers',
					'PLACEHOLDER_PWD3': 'Leave blank if not changing',
					'BOUND': 'Already Bound',
					'BIND_NOW': 'Link Account',
					'AUTH_INFO': 'Social Media Account',
					'EDIT_SUCCESS': 'Successfully!',
				},
			},
			algo: {
				'en': {
					'TITLE': 'Our Prediction Algorithm Models',
					'INFO': ['Using the classic Poisson model, we input historical team performance, seasonal stats and multi-dimensional game data, applying conditional probability, parameter optimization and high-precision data fitting to calculate the probability distribution of goals and scores for each match.', 'Based on the Margin theory in mathematics, this model deeply analyzes the dynamic changes in odds, combining team history and recent trends. It calculates and accurately captures subtle differences between odds, using scientific logic to reveal direction closer to the actual results.', 'Based on the Divergence formula in mathematics, this model quantifies the fundamental data differences between teams, combining odds fluctuations with discrete value calculations and dynamic weight allocation to capture underlying patterns, offering a comprehensive view of the match\'s multiple possibilities.'],
					'MATCH_NUM': 'The results for the next <em>?1</em> matches have been calculated.'
				}
			},
			poster: {
				'en': {
					'TURTOR': {
						'TITLE': 'Create and Share Match Posters Easily.',
						'TEXT': 'Pick your favorite matches and generate a fixture poster. Share this poster with your friends as your must-watch matches list.<br />You can share the poster in two ways: as a URL or an image. The poster adapts seamlessly for both PC and mobile devices when accessed via the URL.',
						'STEP':['Click "Generate a Poster" on the homepage to start.', 'Select your preferred matches and click "Add to Poster".', 'Review your selected matches and click "Generate Poster".', 'Share the generated poster as a link or image with your friends.']
					},
					'ERROR':['The poster has been automatically deleted due to the match with abnormal status.<br />You can continue to add other matches to generate a new poster.'],
					'GOT_IT': 'I got it',
				}
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/langConfig.js